var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupVisualization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5129 0.0883789H1.09374C0.933106 0.0883789 0.802734 0.21875 0.802734 0.379387V11.7974C0.802734 11.958 0.933106 12.0884 1.09374 12.0884H12.5117C12.6724 12.0884 12.8027 11.958 12.8027 11.7974V0.379387C12.8039 0.21875 12.6724 0.0883789 12.5129 0.0883789ZM12.3383 3.01359H4.34139V0.553991H12.3371V3.01359H12.3383ZM3.87578 6.3206V8.83258H1.26835V6.3206H3.87578ZM1.26835 5.85499V3.4792H3.87578V5.85499H1.26835ZM4.34139 6.3206H12.3371V8.83258H4.34139V6.3206ZM4.34139 5.85499V3.4792H12.3371V5.85499H4.34139ZM3.87578 0.553991V3.01359H1.26835V0.553991H3.87578ZM1.26835 9.2982H3.87578V11.6228H1.26835V9.2982ZM4.34139 11.6216V9.2982H12.3371V11.6228H4.34139V11.6216Z",
    fill: "#2C3421"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupVisualization);
export default __webpack_public_path__ + "static/media/groupVisualization.c327a74c044ea3cab8bfe4bad273c792.svg";
export { ForwardRef as ReactComponent };